<template>
  <div v-if="show" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-container" @click.stop>
      <div class="modal-header">
        <h3>Select Pre-Charge Product</h3>
        <button @click="closeModal" class="close-btn">&times;</button>
      </div>

      <div class="modal-body">
        <p>Please select one pre-charge product to add to your cart:</p>

        <div class="product-list">
          <div
            v-for="product in products"
            :key="product.product_id"
            class="product-item"
            @click="selectProduct(product)"
          >
            <div class="product-info">
              <img
                v-if="product.photo"
                :src="product.photo"
                :alt="product.product_name_en"
                class="product-image"
              />
              <div v-else class="product-image-placeholder">
                <span>No Image</span>
              </div>

              <div class="product-details">
                <h4>{{ product.product_name_en }}</h4>

                <!-- Show available sale codes/prices -->
                <div class="sale-codes">
                  <div
                    v-for="saleCode in product.sale_code"
                    :key="saleCode.pro_sale_code_id"
                    class="sale-code-item"
                    :class="{
                      'default-uom': saleCode.unit_of_measure.is_default
                    }"
                  >
                    <span class="uom">{{
                      saleCode.unit_of_measure.uom_name_en
                    }}</span>
                    <span class="price"
                      >${{
                        defaultPrice(
                          saleCode.product_id,
                          dataSend.guest_level_id,
                          saleCode.uom_id
                        )
                      }}</span
                    >
                    <span
                      v-if="saleCode.unit_of_measure.is_default"
                      class="default-badge"
                    >
                      Default
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button @click="closeModal" class="btn btn-cancel">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PreChargeProductModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: () => []
    },
    dataSend: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', [
      'defaultPrice'
    ]),
  },
  methods: {
    selectProduct(product) {
      this.$emit('product-selected', product)
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    },

    handleOverlayClick() {
      // Close modal when clicking outside
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background-color: #e9ecef;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
}

.product-list {
  margin-top: 15px;
}

.product-item {
  border: 2px solid #eee;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: white;
}

.product-item:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
}

.product-item:last-child {
  margin-bottom: 0;
}

.product-info {
  display: flex;
  align-items: flex-start;
}

.product-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 15px;
  flex-shrink: 0;
}

.product-image-placeholder {
  width: 60px;
  height: 60px;
  background-color: #f0f0f0;
  border-radius: 6px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #999;
  flex-shrink: 0;
}

.product-details {
  flex: 1;
}

.product-details h4 {
  margin: 0 0 5px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.product-category,
.product-group {
  margin: 2px 0;
  color: #666;
  font-size: 13px;
}

.sale-codes {
  margin-top: 10px;
}

.sale-code-item {
  display: inline-block;
  background: #f0f0f0;
  padding: 6px 10px;
  border-radius: 20px;
  margin-right: 8px;
  margin-bottom: 5px;
  font-size: 12px;
  transition: all 0.2s ease;
}

.sale-code-item.default-uom {
  background: #e3f2fd;
  border: 1px solid #2196f3;
}

.sale-code-item:hover {
  background: #e0e0e0;
}

.sale-code-item.default-uom:hover {
  background: #bbdefb;
}

.uom {
  font-weight: 600;
  margin-right: 5px;
  color: #333;
}

.price {
  color: #007bff;
  font-weight: 700;
}

.default-badge {
  background: #2196f3;
  color: white;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: right;
  background-color: #f8f9fa;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
}

.btn-cancel:hover {
  background-color: #5a6268;
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 10px;
  }

  .product-info {
    flex-direction: column;
  }

  .product-image,
  .product-image-placeholder {
    margin-right: 0;
    margin-bottom: 10px;
    align-self: center;
  }

  .modal-header {
    padding: 15px;
  }

  .modal-body {
    padding: 15px;
  }
}
</style>
